import { connect } from "react-redux";
import { getCurrentOffer } from "src/components/MyGarage/TableCompare/lib";
import { ApplicationStore } from "src/store";
import CreditApproved from "./CreditApproved";

function mapStateToProps({ currentDeal, vehicles }: ApplicationStore) {
    const vehicle = vehicles.entities[currentDeal.vin!];
    const currentOffer = getCurrentOffer(vehicle);
    return {
        bankName: currentOffer.lender,
    };
}

export default connect(mapStateToProps)(CreditApproved);
